import script from "./RelayerAccounts.vue?vue&type=script&setup=true&lang=ts"
export * from "./RelayerAccounts.vue?vue&type=script&setup=true&lang=ts"

import "./RelayerAccounts.vue?vue&type=style&index=0&id=43140a92&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43140a92"]])

export default __exports__